'use client'

import { useState, useEffect } from "react";
import "../BookInteractionPill/book-interaction-pill.css"
import { track } from '@vercel/analytics';
import { BookInterface } from "../../books/types/book";
import { generateBookSlug, extractUrnNumber } from "../../books/utils/formatters";
import { useIsClient } from "@/hooks/useBrowser";
type ShareButtonProps = {
  share_id?: string;
  openPopout: string | null;
  setOpenPopout: React.Dispatch<React.SetStateAction<string | null>>;
  book: BookInterface | null;
};


export default function ShareButton({  share_id, openPopout, setOpenPopout, book }: ShareButtonProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [copiedBook, setCopiedBook] = useState(false);
  const [copiedPage, setCopiedPage] = useState(false);
  const [shareableUrl, setShareableUrl] = useState('');
  const [shareableBookUrl, setShareableBookUrl] = useState('');
  const [isSearchPage, setIsSearchPage] = useState(false);
  const isClient = useIsClient();

  
  useEffect(() => {
    if (!isClient) return;

    const currentUrl = window.location;
    const path = currentUrl.pathname;
    const isSearch = path.includes('/discover');
    setIsSearchPage(isSearch);
    
    setShareableUrl(getShareableUrl(true));
    
    if (book && book.title && book.author && book.work_urn) {
      const workUrn = extractUrnNumber(book.work_urn);  
      const bookSlug = generateBookSlug(book.title, book.author, workUrn);
      const baseUrl = `${getShareableUrl(false)}`.split('/').slice(0, 3).join('/');
      setShareableBookUrl(`${baseUrl}/book/${bookSlug}`);
    } else {
      setShareableBookUrl('');
    }
  }, [book, isClient]);
  useEffect(() => {
    setIsOpen(false);
  }, [share_id]);

  const getShareableUrl = (includeParams = true) => {
    if (!isClient) return '';

    if (typeof window === 'undefined') return '';
    const url = window.location;
    return includeParams ? url.href : `${url.protocol}//${url.host}${url.pathname}`;
  };

  useEffect(() => {
    setIsOpen(openPopout === "share");
  }, [openPopout]);

  const handleClick = () => {
    track("Share Button Clicked");
    setOpenPopout(isOpen ? null : "share");
  };

  const handleCopy = (url: string, type: 'book' | 'search') => {
    if (!isClient || !navigator?.clipboard) {
      console.error('Clipboard API not available');
      return;
    }
    navigator.clipboard.writeText(url).then(() => {
      if (type == 'book'){
        setCopiedBook(true)
      }
      if(type == 'search'){
        setCopiedPage(true)
      }
      track('URL Copied', { type });
      setTimeout(() => {
        setCopiedPage(false)
        setCopiedBook(false);
      }, 2000);
    });
  };

  const getWhatsappLink = (url: string) => {
    return `https://api.whatsapp.com/send?text=${encodeURIComponent(url)}`;
  };
    return (
      <div className="share-button relative">
        {openPopout === "share" && isOpen && (
          <div className="">
            {shareableBookUrl && (
            <>
              <a 
                href={getWhatsappLink(shareableBookUrl)} 
                target="_blank" 
                rel="noopener noreferrer"
                onClick={() => track('WhatsApp Share', { type: 'book' })}
              >
                Share Book on WhatsApp
              </a>
              <button 
                onClick={() => handleCopy(shareableBookUrl, 'book')}
              >
                {copiedBook ? "Copied!" : "Copy Link to Book"}
              </button>
            </>
          )}
          {isSearchPage && (
            <>
            <a 
              href={getWhatsappLink(shareableUrl)} 
              target="_blank" 
              rel="noopener noreferrer"
              onClick={() => track('WhatsApp Share', { type: 'search' })}            >
             Share Results on WhatsApp
            </a>
            <button onClick={() => handleCopy(shareableUrl, 'search')}>
              {copiedPage ? "Copied!" : "Copy Link to Search"}
            </button>
            </>
          )}       
          </div>
        )}
        <button onClick={handleClick} className="action-button">
         Share
        </button>
      </div>
    );
  };
